import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import roTranslations from './locales/ro.json';
import huTranslations from './locales/hu.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  ro: {
    translation: roTranslations,
  },
  hu: {
    translation: huTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ro',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
  });

// Set Romanian as default for new users if no language preference exists
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('ro');
}

export default i18n;
